import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 決算日基準 */
enum SettlementDateCriteria {
  eom = '1',
  one = '2',
  two = '3',
}

const nameConfig = {
  eom: new Map([
    [Locale.ja, '月末日'],
    [Locale.en, 'Last Day Month'],
  ]),
  one: new Map([
    [Locale.ja, '決算日基準1'],
    [Locale.en, 'Settlement Date Basis One'],
  ]),
  two: new Map([
    [Locale.ja, '決算日基準2'],
    [Locale.en, 'Settlement Date Basis Two'],
  ]),
};

const toEnum = rawValueToEnum(SettlementDateCriteria, SettlementDateCriteria.eom);
const toDisplay = enumToName(SettlementDateCriteria, nameConfig);
const toDisplayWithPrefix = enumToName(SettlementDateCriteria, nameConfig, { prefix: true });

export const settlementDateCriteria = {
  enum: SettlementDateCriteria,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { SettlementDateCriteria };
